<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div class="right-menu">
      <div class="avatar-wrapper cup" @click="routerTo">
        <img src="https://jiaxiaoshetiyu-prod2.oss-cn-hangzhou.aliyuncs.com/quchucai/admin/img/undo.png" alt="" class="avatar-img" />
        <!-- <i class="el-icon-sort"></i> -->
        <div class="userName">返回赛事中心</div>
      </div>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-sort"></i>
          <div class="userName">切换身份</div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <a href="javascript:;" @click="changeIdentity(1)">
            <el-dropdown-item>选手身份</el-dropdown-item>
          </a>
          <el-dropdown-item divided @click.native="changeIdentity(2)">
            <span style="display: block">领队身份</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="changeIdentity(3)">
            <span style="display: block">教练身份</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-user-solid"></i>
          <div class="userName">{{ identity == 2 ? '领队' : identity == 3 ? '教练' : identity == 1 ? '选手' : '' }}{{ '-' + name }}</div>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <a href="javascript:;" @click="editPassword">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </a>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%" :close-on-press-escape="false">
      <el-form ref="form" class="setInputMedium" :model="form" label-width="120px" :rules="formRules">
        <el-form-item label="旧密码" prop="oldPasswd">
          <el-input v-model="form.oldPasswd" auto-complete="off" placeholder="请输入旧密码" type="password" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPasswd">
          <el-input v-model="form.newPasswd" auto-complete="off" placeholder="请输入新密码" type="password" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="surePasswd">
          <el-input v-model="form.surePasswd" auto-complete="off" placeholder="请确认新密码" type="password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" class="buttonPrimary" @click="handleSubmit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { changepassword, identitySelected } from '@/api/base'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'
import Aes from '@/utils/aes'

export default {
  components: {
    Breadcrumb,
    Hamburger
    // ErrorLog,
    // Screenfull
    // SizeSelect,
    // Search
  },
  data() {
    var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,20}')
    var checkPasswd = (rule, value, callback) => {
      if (!pwdRegex.test(value)) {
        callback(new Error('密码为6-20位数字字母组合'))
      } else {
        callback()
      }
    }
    return {
      form: {
        surePasswd: '',
        oldPasswd: '',
        newPasswd: ''
      },
      dialogVisible: false,
      formRules: {
        oldPasswd: [{ required: true, message: '请输入旧密码', trigger: 'change' }],
        newPasswd: [{ validator: checkPasswd, required: true, message: '密码为6-20位数字字母组合' }],
        surePasswd: [{ validator: checkPasswd, required: true, message: '密码为6-20位数字字母组合' }]
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    ...mapState({
      name: (state) => state.user.name,
      title: (state) => state.user.title,
      identity: (state) => state.user.userReceptionInfo.identity || ''
    })
  },
  methods: {
    routerTo() {
      this.$store.commit('user/SET_TAB_INDEX', 0)
      this.$router.push('/home/homePage')
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changepassword()
        } else {
          return false
        }
      })
    },
    changepassword() {
      if (this.form.newPasswd !== this.form.surePasswd) {
        this.$message({
          type: 'warning',
          message: '两次密码不一致!'
        })
      } else {
        changepassword({
          oldPassword: Aes.encrypt(this.form.oldPasswd.trim()),
          newPassword: Aes.encrypt(this.form.newPasswd.trim())
        }).then((res) => {
          if (res.code === '1000') {
            this.$message({
              type: 'success',
              message: '修改密码成功!'
            })
            this.$store.dispatch('user/logout')
            this.$router.push(`/?redirect=${this.$route.fullPath}`)
          }
        })
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push('/')
    },
    editPassword() {
      this.dialogVisible = true
    },
    async changeIdentity(identity) {
      const res = await identitySelected({
        identity
      })
      if (res.code === '1000') {
        this.$store.dispatch('user/getAuthUserInfo')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-img {
  width: 23px;
  height: 23px;
}
.cup {
  cursor: pointer;
}
.demo-input-suffix {
  line-height: 36px;
  display: flex;
  margin-bottom: 30px;
  .txt {
    width: 80px;
    text-align: right;
  }
  .el-input {
    flex: 1;
  }
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    // .avatar-container {
    //   margin-right: 30px;

    .avatar-wrapper {
      // margin-top: 5px;
      position: relative;
      padding-right: 15px;
      display: flex;
      align-items: center;
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .userName {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #4f4b5c;
      }
      .el-icon-sort {
        background: #404c60;
        border-radius: 4px;
        font-size: 14px;
        color: #ffffff;
        padding: 2px;
      }
    }
    // }
    .zixun {
      display: inline-block;
      line-height: 50px;
      height: 100%;
      vertical-align: text-bottom;
      padding: 0 8px;
    }
    .userName {
      display: inline-block;
      line-height: 50px;
      height: 100%;
      vertical-align: text-bottom;
      padding-left: 8px;
      font-size: 14px;
    }
  }
}
.schhol {
  float: right;
  line-height: 50px;
  padding: 0 15px;
  font-size: 14px;
}
</style>
